<template>
  <div>
    <v-form
      v-model="valid"
      ref="passengerDetailsForm"
      @submit.prevent="validatePassengerDetails"
    >
      <div v-if="allFlights.length > 0" class="passenger_details">
        <div v-for="(flight, i) in allFlights" :key="flight.f_id + i">
          <div
            class="viewport mt-4"
            v-if="!samepassengers && flight.type == 'return'"
          >
          <h2 class="primary--text">Returning {{ paxTerm }}</h2>
          </div>
          <div
            class="viewport"
            v-else-if="allFlights.length === 2"
          >
            <h2 class="primary--text">Departing {{ paxTerm }}</h2>
          </div>
          <div
            v-for="(pType, name, index) in flight.passengers"
            :key="name + index"
          >
            <div v-if="
              (
                  (
                  flight.passengers.Child !== undefined &&
                  flight.passengers.Child.length > 0
                )
                ||
                (
                  flight.passengers.Infant !== undefined &&
                  flight.passengers.Infant.length > 0
                )
              )
              &&
                pType.length > 0
              "
            >
              <h3 class="primary--text">{{ name }} {{ paxTerm }}</h3>
            </div>
            <div v-for="p in pType" :key="name + '_' + p.id + '_' + index">
              <v-card flat class="pt-4">
                <v-container>
                  <v-layout row wrap justify-start align-center>
                    <v-flex :class="messageClass" xs12 sm3 shrink>
                      <v-text-field
                        label="First Name"
                        v-model="p.fname"
                        @input="set_field(p)"
                        name="fname[]"
                        :rules="[rules.minText, rules.required]"
                        required
                        outline
                        clearable
                        box
                      ></v-text-field>
                    </v-flex>
                    <v-flex :class="messageClass" xs12 sm3 shrink>
                      <v-text-field
                        label="Last Name"
                        v-model="p.lname"
                        @input="set_field(p)"
                        :rules="[rules.minText, rules.required]"
                        name="lname[]"
                        required
                        outline
                        clearable
                      ></v-text-field>
                    </v-flex>
                    <v-flex
                      v-if="name === 'Adult'"
                      :class="{ messageClass, 'pr-2': true}"
                      xs12
                      sm2
                      shrink
                    >
                      <v-select
                        label="Gender"
                        v-model="p.gender"
                        :items="gender"
                        @input="setGender(p, p.gender)"
                        outline
                        required
                      >
                      </v-select>
                    </v-flex>
                    <v-flex
                      v-if="name === 'Adult'"
                      :class="messageClass"
                      xs12
                      sm2
                      shrink
                    >
                      <v-layout v-if="discountsAvailableDep && flight.type == 'depart'" row >
                        <AddPassengerDiscounts :passenger="p" :saveDiscount="addDiscount" />
                      </v-layout>
                      <v-layout v-else-if="discountsAvailableRet && flight.type == 'return'" row >
                        <AddPassengerDiscounts :passenger="p" :saveDiscount="addDiscount" />
                      </v-layout>
                    </v-flex>
                    <v-spacer></v-spacer>
                  </v-layout>
                </v-container>
              </v-card>
              <v-divider class="py-3"></v-divider>
            </div>
          </div>
        </div>
        <v-layout row wrap class="discounts">
          <v-flex
            xs12
            md6
            v-if="conditions.student === true"
          >
            <div class="discount-box">
              <div style="margin-bottom: 0.5em; font-size: 1em; font-weight: 900;">Students receive a 30% discount on Classic fares</div>
							<div style="margin-bottom: 0.5em; font-weight: bold; font-size: 0.95em;">Student must be attending a Canadian University <span style="white-space: nowrap;">or College.</span></div>
              <div style="margin: 0.7em 0; font-size: 0.9em;">(Must provide proof of current enrollment upon check-in)</div>
              <div style="margin: 0.7em 0; font-size: 0.9em;">**Rate is not applicable to high school students.</div>
              <div style="font-weight: bold;"><a target="_blank" href="/schedules-fares/fares/">More Information on Student Fares &rarr;</a></div>
              <v-checkbox
                v-model="studentDiscountConfirmed"
                label="I agree to these conditions"
								@click.native="senStuAgreed()"
              ></v-checkbox>
            </div>
          </v-flex>
          <v-flex
            xs12
            md6
            v-if="conditions.senior === true"
          >
            <div class="discount-box">
							<div style="margin-bottom: 0.5em; font-size: 1em; font-weight: 900;">Seniors receive a 10% discount on Classic fares</div>
              <div style="margin-bottom: 0.5em; font-weight: bold; font-size: 0.95em;">Passengers must be 65 years or older to qualify for the discounted Senior Fare.</div>
              <div style="font-weight: bold;"><a target="_blank" href="/schedules-fares/fares/">More Information on Senior Fares &rarr;</a></div>
              <v-checkbox
                v-model="seniorDiscountConfirmed"
                label="I agree to these conditions"
								@click.native="senStuAgreed()"
              ></v-checkbox>
            </div>
          </v-flex>
        </v-layout>
        <SpecialConditions />
      </div>
      <div v-else>
        <p class="error pa-3">
          No details found. Please go back and select passenger and flight
          options.
        </p>
      </div>
    </v-form>
  </div>
</template>

<script>
import Vue from "vue";
import Shared from "@/mixins/Shared";
import { createHelpers } from "vuex-map-fields";
import SpecialConditions from "@/components/forms/SpecialConditions.vue";
import AddPassengerDiscounts from "@/components/forms/sections/AddPassengerDiscounts.vue"

const { mapFields } = createHelpers({
  getterType: "getField",
  mutationType: "updateField"
});

export default {
  name: "AddPassengerDetails",
  data: function() {
    return {
      valid: true,
      error: false,
      hasMessages: false,
      pax: [],
      gender: ["Male", "Female", "X"],
      seniorDiscountConfirmed: false,
      studentDiscountConfirmed: false,
      rules: {
        minText: value => (value != null && value.length > 1) || "Incomplete",
        required: value => !!value || "Incomplete"
      }
    };
  },
  methods: {
    addDiscount(p) {
      const discounts = this.getDiscounts();
      this.student = discounts[0];
      this.senior = discounts[1];
      this.$store.commit("setDiscount", p);
      this.validatePassengerDetails();
      this.senStuAgreed();
    },
    getDiscounts() {
      const pax = this.getActivePassengers();
      let disc = [false, false];
      pax.forEach(p => {
        if (p.discounts[0].value === true) {
          disc[0] = true;
          // this.conditions.Student = true;
        }
        if (p.discounts[1].value === true) {
          disc[1] = true;
          // this.conditions.Senior = true;
        }
      });
      return disc;
    },
		senStuAgreed() {
			if(
				(
					this.conditions.senior === true &&
					this.seniorDiscountConfirmed === false
				) ||
				(
					this.conditions.student === true &&
					this.studentDiscountConfirmed === false
				)
			)
			{
				this.setError(
					"Passengers",
					"Please agree to the Student/Senior discount conditions"
				);
			}
			else
			{
				this.$store.dispatch("UNSET_ERRORS", "Passengers");
        this.validatePassengerDetails();
			}
		}
  },
  computed: {
    messageClass() {
      return {
        "md-invalid": this.hasMessages
      };
    },
    allFlights() {
      let fArr = [];
      if (this.departFlight !== null) {
        fArr.push(this.departFlight);
        if (
          this.samepassengers === false &&
          this.returnFlight !== null &&
          this.returnFlight.passengers !== undefined
        ) {
          // const pax = Object.keys(this.returnFlight.passengers.Adult);
          if (this.form_fields.pax_a_r >= 1 || this.form_fields.pax_a_c >= 1 || this.form_fields.pax_a_i >= 1) {
            fArr.push(this.returnFlight);
          }
        }
      }
      return fArr;
    },
		discountsAvailableDep() {

			// departing flight is set and fare type is standard
			if(
				(
					this.departFlight !== null &&
					this.departFlight.fare.fare_type === "standard"
				) ||
				(
					this.departFlight !== null &&
					this.departFlight.fare.fare_type !== "standard" &&
					this.returnFlight !== null &&
					this.returnFlight.fare.fare_type === "standard" &&
					this.samepassengers === true
				)
			)
			{
				return true;
			}
			return false;
		},
		discountsAvailableRet() {

			// return flight is not set, or is a standard fare type
			if( this.returnFlight !== null && this.returnFlight.fare.fare_type === "standard" )
			{
				return true;
			}
			return false;
		}
  },
  mixins: [Shared],
  components: {
    SpecialConditions,
    AddPassengerDiscounts
  },
  mounted() {
    this.validatePassengerDetails();
    this.checkDiscounts();
    this.senStuAgreed();
  }
};
</script>

<style lang="scss" scoped>
.checkbox {
  display: flex;
}
</style>
